import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { trackPageView } from "@/lib/tracking";

/** Registers a page view whenever the route changes (idle, never blocks render). */
export function usePageTracking() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => {
    if (typeof window === "undefined") return;
    const ric = (window as unknown as { requestIdleCallback?: (cb: () => void) => number }).requestIdleCallback;
    const cic = (window as unknown as { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback;
    const id = ric ? ric(() => trackPageView(pathname)) : window.setTimeout(() => trackPageView(pathname), 200);
    return () => {
      if (ric && cic) cic(id);
      else window.clearTimeout(id as number);
    };

  }, [pathname]);
}
